import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Methods } from "../../../shared/methods";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { TaxService } from "../../../services/tax.service";
import { SaleService } from "../../../services/sale.service";

@Component({
  selector: 'app-taxes',
  templateUrl: './taxes.component.html',
  styleUrls: ['./taxes.component.css']
})
export class TaxesComponent implements OnInit {
  @Input() edit = true;
  @Input() proposal_id;
  @Input() country;
  @Input() state_tax;
  @Output() nuevoTax: EventEmitter<number>;
  public mtds: Methods = new Methods();
  public states: Array<any> = [];
  public loading = false;
  public aplicando = false;
  public borrando = false;
  public aplicado = false;

  constructor(
    private _router: Router,
    private _taxService: TaxService,
    private _soService: SaleService
  ) {
    this.nuevoTax = new EventEmitter();
  }

  ngOnInit() {
    this.aplicado = this.state_tax !== null;
    this.getData();
  }

  getData() {
    this.loading = true;
    this._taxService.showAll().subscribe(
      (r) => {
        console.log(r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.states = r.data;
          this.mtds.initTable("#taxTable", 1, "asc");
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (err) => {
        this.mtds.notifyError(err.statusText);
        this.loading = false;
      }
    );
  }

  aplicar() {
    this.aplicando = true;

    let json = {
      taxid: this.state_tax,
    };

    this._soService.aplicarTax(this.proposal_id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.status === "success") {
          this.nuevoTax.emit(r.data.tax);
          this.aplicado = true;
          this.mtds.notifySuccess("Tax has been applied to the proposal");
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.aplicando = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.aplicando = false;
      }
    );
  }

  borrar() {
    this.borrando = true;

    this._soService.clearTax(this.proposal_id).subscribe(
      (r) => {
        console.log(r);
        if (r.status === "success") {
          this.nuevoTax.emit(null);
          this.state_tax = null;
          this.aplicado = false;
          this.mtds.notifySuccess("Tax has been removed to the proposal");
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.borrando = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.borrando = false;
      }
    );
  }
}